import { BiInfoCircle } from 'react-icons/bi';
import { HStack } from '../HStack';
import { Text } from '../Text';
import theme from '../../theme';

export const ErrorBanner = ({
  text,
  children,
}: {
  text?: string;
  children?: React.ReactNode;
}) => {
  return (
    <HStack className='gap-2 rounded-[5px] bg-red-100 px-3 py-2'>
      <BiInfoCircle size={20} color={theme.colors.red[600]} />
      {text ? (
        <Text font='regular-sm' color={'red-600'}>
          {text}
        </Text>
      ) : (
        children
      )}
    </HStack>
  );
};
